import { Box, Tab, Tabs, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ItemDisplayInfoCard from './item-display-info-card.component';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function getFullLanguage(languageCode: string) {
  switch (languageCode) {
    case 'EN':
      return 'English';
    case 'FR':
      return 'French';
    case 'SPA':
      return 'Spanish';
  }
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const ItemDisplayInfoTabs = ({ displayInfo }) => {
  const { t } = useTranslation();

  const languages = useMemo(
    () =>
      displayInfo.map((info, index) => ({
        label: getFullLanguage(info.langCode),
        value: index,
        children: <ItemDisplayInfoCard info={info} />,
      })),
    [displayInfo],
  );

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', marginTop: '2%' }}>
      <Box>
        <Typography gutterBottom variant="h2">
          {t('page.products.items.displayInfo.displayInfoTitle')}
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Display Information"
        >
          {languages.map(({ label }, index) => (
            <Tab
              data-testid={`Language${label}`}
              label={label}
              {...a11yProps(index)}
              key={index}
            />
          ))}
        </Tabs>
      </Box>
      {languages.map(({ children, value: tabValue }, index) => (
        <CustomTabPanel value={value} index={index} key={index}>
          {children}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default ItemDisplayInfoTabs;
